import { flattenObj } from "../tag-based-products";

export async function handleDescription(parentElement: HTMLElement) {
  const element = document.createElement("div");
  const id = (element.getAttribute("data-helium-product-handle") ||
    window.location.pathname.split("/").at(-1)) as string;
  element.classList.add(...["hp-text-sm", "hp-px-4", "hp-my-4"]);
  element.style.whiteSpace = "pre-line";
  const description = await window.helium.datastore.getUiDescription({ id });

  element.innerHTML = `<div class='hp-flex hp-flex-col hp-items-center'>
<h3 class="hp-heading  hp-w-full hp-text-start ">Product Description</h3>
    <p class="hp-line-clamp-3 w-full">${description.description}</p>
    <button class='hp-mt-4  hp-text-black hp-text-blue-900 hp-mx-auto hp-px-4 hp-py-2 hp-rounded-full hp-text-sm'>Read more</button>
  </div>`;
  const button = element.querySelector("button");
  button.onclick = async () => {
    const el = element.querySelector("p");
    if (el.classList.contains("hp-line-clamp-3")) {
      el.classList.remove("hp-line-clamp-3");
      button.innerHTML = "Read less";
      return;
    }
    el.classList.add("hp-line-clamp-3");
    button.innerHTML = "Read more";
  };
  parentElement.appendChild(element);
}
